import { useMemo } from 'react'
import { useNavHierarchyAdmin } from '../nav-v2/NavMenuHierarchy'
import { NavSectionV3, type NavMenuHierarchyV3 } from './navSectionV3'

// Admin v3 reuses the v2 admin pipeline (`useNavHierarchyAdmin`) and reshapes
// its flat L1 list into a single-section v3 hierarchy under
// `NavSectionV3.Global`. `TdsNavigationBar` suppresses the section header for
// `Global`, preserving v2 admin's "no section headers" layout exactly.
//
// Why reuse the v2 pipeline: admin nav items are registered by domains via
// `domainAdminNavigationEntriesV2` keyed by `AdminNavEntryPointV2`. There's no
// parallel v3 entry-point registry; building one would force every admin domain
// to re-register entries. The wrapper below runs the existing attach/access/
// clean pipeline, then reshapes the result. Output is identical content.
export const useNavHierarchyAdminV3 = (doAccessCheck: boolean = true) => {
  const { navMenuHierarchy: v2 } = useNavHierarchyAdmin(doAccessCheck)

  return useMemo(() => {
    const navMenuHierarchy: NavMenuHierarchyV3 = {
      navBarColor: v2.navBarColor,
      navBarColorHover: v2.navBarColorHover,
      type: v2.type,
      homeRoute: v2.homeRoute,
      sections: [{ id: NavSectionV3.Global, l1s: v2.hierarchy }],
    }
    return { navMenuHierarchy }
  }, [v2])
}
